import { render, staticRenderFns } from "./ChildInvite.pug?vue&type=template&id=49f3bc36&scoped=true&lang=pug&"
import script from "./ChildInvite.vue?vue&type=script&lang=js&"
export * from "./ChildInvite.vue?vue&type=script&lang=js&"
import style0 from "./ChildInvite.scss?vue&type=style&index=0&id=49f3bc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3bc36",
  null
  
)

export default component.exports